<template>
  <div class="layout-slide-menu">
    <el-menu  :collapse="isCollapse" :default-active="activeIndex">
      <template v-for="(menu, index) in menuList">
        <template v-if="hasPermission(menu.permission)">
          <el-menu-item
            v-if="!menu.children || menu.children.length == 0"
            :key="index"
            :index="menu.path"
            @click="goPath(menu.path)"
          >
            <i v-if="menu.icon" :class="menu.icon" />
            <span slot="title">{{ generateTitle(menu.title) }}</span>
          </el-menu-item>
          <el-submenu v-else :key="index" :index="menu.path">
            <template slot="title">
              <i v-if="menu.icon" :class="menu.icon" />
              <span slot="title">{{ generateTitle(menu.title) }}</span>
            </template>
            <template v-for="(menu2, index) in menu.children">
              <template v-if="hasPermission(menu2.permission)">
                <el-menu-item v-if="menu2.show" :key="index" :index="menu2.path" @click="goPath(menu2.path)">
                  <i v-if="menu2.icon" :class="menu2.icon" />
                  <span slot="title">{{ generateTitle(menu2.title) }}</span>
                </el-menu-item>
              </template>
            </template>
          </el-submenu>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import {
  generateTitle
} from '@/utils/i18n'
export default {
  name: 'SlideMenu',
  props: ['isCollapse'],
  watch:{
$route:{
  handler(newval){
      if(newval.path=='/couponManagement/ManualRelease' && localStorage.getItem('saveMoney') && localStorage.getItem('saveMoney')==1){
  this.activeIndex=newval.path
  this.$router.go(0)
  // setTimeout(()=>{
    // this.$forceUpdate()
  // },1000)
  }
  else{
    // this.activeIndex='/Welcome'
  }
  },
  deep:true
}
  },
  data() {
    return {
      menuList: [],
      activeIndex:'',
      tempIndex:''
    }
  },
  created() {
    const data = []
    const routes = this.$router.options.routes
    for (var i = 0; i < routes.length; i++) {
      const route = routes[i]
      const path = route.path
      if (path === '/bigScreen' || path === '/' || path === '/Welcome') {
        continue
      }
      const rootId = i
      let rootPath = route.path
      let rootMeta = route.meta
      const children = route.children
      let hasChildren = true

      if (children.length === 1) {
        rootPath += '/' + children[0].path
        rootMeta = children[0].meta
        hasChildren = false
      }
      const rootTitle = rootMeta.title
      const rootPermission = rootMeta.permission
      const rootIcon = rootMeta.icon
      const rootShow = rootMeta.show

      const rootMenu = {
        id: rootId,
        title: rootTitle,
        permission: rootPermission,
        path: rootPath,
        icon: rootIcon,
        show: rootShow,
        children: []
      }
      data.push(rootMenu)
      if (!hasChildren) {
        continue
      }
      for (var j = 0; j < children.length; j++) {
        const cId = i + '-' + j
        const cRoute = children[j]
        const cPath = rootPath + '/' + cRoute.path
        const cMeta = cRoute.meta
        const cTitle = cMeta.title
        const cPermission = cMeta.permission
        const cIcon = cMeta.icon
        const cShow = cMeta.show
        const cMenu = {
          id: cId,
          title: cTitle,
          permission: cPermission,
          path: cPath,
          icon: cIcon,
          show: cShow
        }
        rootMenu.children.push(cMenu)
      }
    }
    this.menuList = data
  },
  mounted() {
    this.activeIndex = this.$route.path
  },
  methods: {
    generateTitle,
    hasPermission(permission) {
      let flag = false
      const menus = this.$store.state.login.menu
      if (!menus) {
        return false
      }
      for (let i = 0; i < menus.length; i++) {
        const menu = menus[i]
        if (menu === permission) {
          flag = true
          break
        }
      }
      return flag
    },
    goPath(path){
            localStorage.removeItem('queryForm')
      localStorage.removeItem('pageNo')
      if(path === this.$route.path){
        this.$router.go(0)
      }else{
        this.$router.push({path:path})
      }
    }
  }
}
</script>

<style lang="less">
  @import "./SlideMenu.less";
</style>



// WEBPACK FOOTER //
// src/components/SlideMenu.vue